/**
 * A grid resolution. Not always a number hence the optional value property.
 */
export type Resolution = {
	name: string;
	value?: number;
};

export const makeResolution = (name: string): Resolution => {
	const f = parseFloat(name);
	return {
		name,
		value: isNaN(f) ? undefined : f
	};
};
